import { API_VERSION_ONE, handleAPI } from '../../../../../../itrust_common/utils/apiUtils'

export function versantDiagnosisCodesLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/versant/diagnosis_codes`
  const method = 'GET'

  return {
    type: 'VERSANT_DIAGNOSIS_CODES_LOAD',
    payload: handleAPI(url, filters, method),
  }
}

export function versantProcedureCodesLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/versant/procedure_codes`
  const method = 'GET'

  return {
    type: 'VERSANT_PROCEDURE_CODES_LOAD',
    payload: handleAPI(url, filters, method),
  }
}

export function versantRegisteredLabsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/versant/registered_labs`
  const method = 'GET'

  return {
    type: 'VERSANT_REGISTERED_LABS_LOAD',
    payload: handleAPI(url, filters, method),
  }
}

export function versantLenDesignLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/versant/len_design`
  const method = 'GET'

  return {
    type: 'VERSANT_LEN_DESIGN_LOAD',
    payload: handleAPI(url, filters, method),
  }
}

export function versantLenTreatmentLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/versant/len_treatment`
  const method = 'GET'

  return {
    type: 'VERSANT_LEN_TREATMENT_LOAD',
    payload: handleAPI(url, filters, method),
  }
}

